<div>
  <div class="snackbar-content">
    <span *ngIf="isIconDisplayed"><span class="fa fa-check-circle icon"></span></span>
    <span>{{ text }}</span>
  </div>
</div>
